/* ════════════════════════════════════════════════════════════════════
   BUTTER.ATL — LEAN SITE behaviors
   Ported from lean-site-prototype-v3-taste.html.
   The prototype's hash router and design-notes toggle are dropped:
   WordPress handles routing (each route is its own page load), and notes
   never ship. What remains: scroll-reveal, mobile drawer, intro overlay.
   ════════════════════════════════════════════════════════════════════ */

(function () {
  "use strict";

  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- scroll reveal (premium easing, reduced-motion safe, fail-safe) ----
     Targets major content blocks. The hero is intentionally excluded so it
     never animates in behind the intro curtain.
     Fail-safe guarantees (content can never stay stuck hidden):
      - starting opacity:0 is scoped to .js-reveal (set only when JS runs)
      - reduced-motion OR no IntersectionObserver -> reveal everything now
      - anything already in/above the viewport reveals on init
      - a 1500ms timeout force-reveals every block regardless of scroll */
  var REVEAL_SEL =
    ".sec, .proofband, .cred, .statband, .marquee-sec, .resultsstrip";
  var revealObserver = null;

  function setupReveals(scope) {
    scope = scope || document;
    var blocks = scope.querySelectorAll(REVEAL_SEL);
    blocks.forEach(function (b) {
      b.classList.add("reveal");
    });

    var revealAll = function () {
      var els = scope.querySelectorAll(".reveal");
      for (var i = 0; i < els.length; i++) els[i].classList.add("in");
    };

    if (REDUCED || !("IntersectionObserver" in window)) {
      revealAll();
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add("in");
              revealObserver.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -8% 0px" },
      );
    }

    var vh = window.innerHeight || document.documentElement.clientHeight;
    blocks.forEach(function (b) {
      if (b.classList.contains("in")) return;
      var top = b.getBoundingClientRect().top;
      if (top < vh * 0.92) {
        b.classList.add("in");
        return;
      }
      revealObserver.observe(b);
    });

    setTimeout(revealAll, 1500);
  }

  /* ---- mobile drawer ---- */
  function initDrawer() {
    var drawer = document.getElementById("drawer");
    var burgerBtn = document.getElementById("burgerBtn");
    if (!drawer || !burgerBtn) return;
    var drawerClose = document.getElementById("drawerClose");

    function openDrawer() {
      drawer.hidden = false;
      document.body.classList.add("noscroll");
      burgerBtn.setAttribute("aria-expanded", "true");
    }
    function closeDrawer() {
      if (drawer.hidden) return;
      drawer.hidden = true;
      document.body.classList.remove("noscroll");
      burgerBtn.setAttribute("aria-expanded", "false");
    }

    burgerBtn.addEventListener("click", openDrawer);
    if (drawerClose) drawerClose.addEventListener("click", closeDrawer);
    drawer.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", closeDrawer);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer();
    });
  }

  /* ---- intro overlay (Effect 1, ported from butter-animations.html) ----
     Plays only when #introOverlay is present in the DOM, which the theme
     outputs on the front page only. A real page load of Home replays it;
     navigating to any other page never renders it. Deep links, reduced
     motion, or missing GSAP all skip it gracefully. */
  function initIntro() {
    var overlay = document.getElementById("introOverlay");
    if (!overlay) return;
    var edge = document.getElementById("introEdge");
    var content = document.getElementById("introContent");
    var done = false;
    var tl = null;
    var failsafe = null;

    function killIntro() {
      if (done) return;
      done = true;
      clearTimeout(failsafe);
      try {
        if (tl) tl.kill();
      } catch (err) {
        /* noop */
      }
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      document.body.style.overflow = "";
    }

    if (REDUCED || typeof window.gsap === "undefined") {
      killIntro();
      return;
    }

    failsafe = setTimeout(killIntro, 4000);

    overlay.style.pointerEvents = "auto";
    overlay.addEventListener("click", killIntro);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") killIntro();
    });

    try {
      document.body.style.overflow = "hidden";

      gsap.set(overlay, { yPercent: 0, y: 0, autoAlpha: 1 });
      gsap.set(edge, { yPercent: 28, y: 0, autoAlpha: 0 });
      gsap.set(content, { yPercent: 0, y: 30, autoAlpha: 0 });

      tl = gsap.timeline({
        defaults: { ease: "power3.out" },
        onComplete: killIntro,
      });

      tl.to(content, { y: 0, autoAlpha: 1, duration: 0.65 }, 0.15);
      tl.to({}, { duration: 0.7 });
      tl.to(content, {
        yPercent: -160,
        autoAlpha: 0,
        duration: 0.45,
        ease: "power2.in",
      });
      tl.to(
        edge,
        { yPercent: 0, autoAlpha: 1, duration: 0.2, ease: "power2.out" },
        "-=0.12",
      );
      tl.to(
        overlay,
        { yPercent: -125, duration: 1.05, ease: "power3.inOut" },
        "-=0.18",
      );
    } catch (err) {
      killIntro();
    }
  }

  /* ---- carousel enhancer ----
     For each .work-carousel on the page:
       - Skip if 0 or 1 items (no navigation needed).
       - Wrap in <div class="carousel"> (inserted in place).
       - Inject prev/next <button> controls outside the scrollable track.
       - Prev scrolls left; next scrolls right by one item width + gap.
       - Respects prefers-reduced-motion (uses 'auto' behaviour instead of 'smooth').
       - Prev button hidden at scrollLeft <= 0; next hidden when fully scrolled.
       - State updated on 'scroll' and 'resize'.
     Entirely fail-safe: wrapped in try/catch, guards every element reference. */
  function initCarousels() {
    try {
      var carousels = document.querySelectorAll(".work-carousel");
      if (!carousels.length) return;

      carousels.forEach(function (track) {
        try {
          var items = track.querySelectorAll(".work-carousel__item");
          if (items.length <= 1) return;

          /* Wrap */
          var wrapper = document.createElement("div");
          wrapper.className = "carousel";
          track.parentNode.insertBefore(wrapper, track);
          wrapper.appendChild(track);

          /* Buttons */
          var prev = document.createElement("button");
          prev.className = "carousel__nav carousel__nav--prev";
          prev.setAttribute("aria-label", "Previous");
          prev.innerHTML = "&#8249;"; /* ‹ */

          var next = document.createElement("button");
          next.className = "carousel__nav carousel__nav--next";
          next.setAttribute("aria-label", "Next");
          next.innerHTML = "&#8250;"; /* › */

          wrapper.appendChild(prev);
          wrapper.appendChild(next);

          function scrollAmount() {
            var firstItem = track.querySelector(".work-carousel__item");
            if (!firstItem) return Math.round(track.clientWidth * 0.8);
            /* gap is defined in CSS as 14px */
            return firstItem.offsetWidth + 14;
          }

          var scrollBehavior = REDUCED ? "auto" : "smooth";

          next.addEventListener("click", function () {
            track.scrollBy({ left: scrollAmount(), behavior: scrollBehavior });
          });

          prev.addEventListener("click", function () {
            track.scrollBy({ left: -scrollAmount(), behavior: scrollBehavior });
          });

          function updateButtons() {
            try {
              var atStart = track.scrollLeft <= 0;
              var atEnd =
                track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
              prev.disabled = atStart;
              prev.setAttribute("aria-disabled", atStart ? "true" : "false");
              next.disabled = atEnd;
              next.setAttribute("aria-disabled", atEnd ? "true" : "false");
            } catch (err) {
              /* noop */
            }
          }

          track.addEventListener("scroll", updateButtons, { passive: true });
          window.addEventListener("resize", updateButtons, { passive: true });

          /* Initial state */
          updateButtons();
        } catch (err) {
          /* noop: guard individual carousel failures */
        }
      });
    } catch (err) {
      /* noop: guard entire feature */
    }
  }

  /* ---- shared lightbox focus helpers ----
     Both lightboxes are modal dialogs, so they manage focus the same way:
     remember what was focused, move focus into the dialog on open, keep Tab
     inside it, and restore focus to the trigger on close. */
  function lightboxFocusables(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll(
        'button, a[href], iframe, video, [tabindex]:not([tabindex="-1"])',
      ),
    );
  }
  function lightboxTrapTab(overlay, e) {
    if (e.key !== "Tab") return;
    var f = lightboxFocusables(overlay);
    if (!f.length) {
      e.preventDefault();
      return;
    }
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ---- lightbox ----
     Click any .lightbox-img to view it large on a dark overlay (the
     full-size file via data-full, falling back to the displayed src).
     Close on overlay/close-button click or Escape. Built once, lazily. */
  function initLightbox() {
    if (!document.querySelector(".lightbox-img")) return;
    var overlay = null;
    var imgEl = null;
    var lastFocus = null;

    function build() {
      overlay = document.createElement("div");
      overlay.className = "lightbox-overlay";
      overlay.setAttribute("role", "dialog");
      overlay.setAttribute("aria-modal", "true");
      overlay.innerHTML =
        '<button class="lightbox-close" aria-label="Close">&#215;</button>' +
        '<img class="lightbox-full" alt="">';
      imgEl = overlay.querySelector(".lightbox-full");
      overlay.addEventListener("click", function (e) {
        if (
          e.target === overlay ||
          e.target.classList.contains("lightbox-close")
        ) {
          closeBox();
        }
      });
      overlay.addEventListener("keydown", function (e) {
        lightboxTrapTab(overlay, e);
      });
      document.body.appendChild(overlay);
    }
    function openBox(src, alt) {
      if (!src) return;
      if (!overlay) build();
      lastFocus = document.activeElement;
      imgEl.src = src;
      imgEl.alt = alt || "";
      overlay.classList.add("open");
      document.body.classList.add("noscroll");
      overlay.querySelector(".lightbox-close").focus();
    }
    function closeBox() {
      if (!overlay || !overlay.classList.contains("open")) return;
      overlay.classList.remove("open");
      document.body.classList.remove("noscroll");
      imgEl.src = "";
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener("click", function (e) {
      var t = e.target.closest ? e.target.closest(".lightbox-img") : null;
      if (!t) return;
      e.preventDefault();
      openBox(t.getAttribute("data-full") || t.currentSrc || t.src, t.alt);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeBox();
    });
  }

  /* ---- video lightbox ----
     Click a .video-trigger (poster + play button) to open its featured
     video on a dark overlay with controls + sound. The player markup lives
     in a sibling <template> so nothing loads until opened; clearing the
     stage on close stops playback. Close on overlay/close-button/Escape. */
  function initVideoLightbox() {
    if (!document.querySelector(".video-trigger")) return;
    var overlay = null,
      stage = null,
      lastFocus = null;

    function build() {
      overlay = document.createElement("div");
      overlay.className = "lightbox-overlay video-overlay";
      overlay.setAttribute("role", "dialog");
      overlay.setAttribute("aria-modal", "true");
      overlay.innerHTML =
        '<button class="lightbox-close" aria-label="Close">&#215;</button>' +
        '<div class="video-stage"></div>';
      stage = overlay.querySelector(".video-stage");
      overlay.addEventListener("click", function (e) {
        if (
          e.target === overlay ||
          e.target.classList.contains("lightbox-close")
        ) {
          closeBox();
        }
      });
      overlay.addEventListener("keydown", function (e) {
        lightboxTrapTab(overlay, e);
      });
      document.body.appendChild(overlay);
    }
    function openBox(tpl) {
      if (!tpl) return;
      if (!overlay) build();
      lastFocus = document.activeElement;
      stage.innerHTML = "";
      stage.appendChild(tpl.content.cloneNode(true));
      overlay.classList.add("open");
      document.body.classList.add("noscroll");
      overlay.querySelector(".lightbox-close").focus();
    }
    function closeBox() {
      if (!overlay || !overlay.classList.contains("open")) return;
      overlay.classList.remove("open");
      document.body.classList.remove("noscroll");
      stage.innerHTML = ""; // unload the iframe/video to stop playback
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener("click", function (e) {
      var t = e.target.closest ? e.target.closest(".video-trigger") : null;
      if (!t) return;
      e.preventDefault();
      var box = t.closest(".video-lightbox");
      // :scope > template keeps the lookup to this wrapper's own player,
      // never a nested one.
      openBox(box ? box.querySelector(":scope > template") : null);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeBox();
    });
  }

  /* ---- hero background video: maximize mobile autoplay ----
     The <video> already has autoplay/muted/loop/playsinline. iOS can still
     block autoplay (e.g. Low Power Mode); force the muted property and retry
     play() on the first user interaction so it starts the moment they touch
     or scroll. */
  function initHeroVideo() {
    var v = document.querySelector(".hero-photo__media video");
    if (!v) return;
    v.muted = true;
    v.setAttribute("muted", "");
    v.playsInline = true;
    function tryPlay() {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    tryPlay();
    function kick() {
      tryPlay();
    }
    window.addEventListener("touchstart", kick, { passive: true, once: true });
    window.addEventListener("scroll", kick, { passive: true, once: true });
    window.addEventListener("pointerdown", kick, { once: true });
  }

  function init() {
    setupReveals(document);
    initDrawer();
    initIntro();
    initCarousels();
    initLightbox();
    initVideoLightbox();
    initHeroVideo();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
